export default [
  {
    path: 'broadcasts',
    name: 'broadcasts',
    component: () => import('@/views/Broadcast/Index.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      template: 'auth',
      name: 'broadcasts',
    },
  },
  {
    path: 'broadcast-content/:id',
    name: 'broadcastContent',
    component: () => import('@/views/Broadcast/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      template: 'auth',
      name: 'broadcasts',
    },
  },
];
